module.exports = __webpack_public_path__ + "static/paris-15-hero-ae5cc53170778ec8a8a8b4ec466cb4ac.png";